function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M22.67 5.05l-1.4 6.42a.976.976 0 01-.29.45.235.235 0 01.02.08 1 1 0 01-1 1H8a1 1 0 01-1-1 .235.235 0 01.02-.08.976.976 0 01-.29-.45l-2.4-9.42V2H1a1 1 0 010-2h4a1 1 0 011 1 .235.235 0 01-.02.08.976.976 0 01.29.45l2.4 9.42V11h10.66v-.05L20.63 5H11a1 1 0 010-2h10a3.941 3.941 0 011.67 2.05zM9.91 15a3 3 0 11-3.09 3 3.042 3.042 0 013.09-3zm.09 4a1 1 0 10-1-1 1 1 0 001 1zm7.91-4a3 3 0 11-3.09 3 3.042 3.042 0 013.09-3zm.09 4a1 1 0 10-1-1 1 1 0 001 1z"
});

var SvgBasket = function SvgBasket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 22.69,
    height: 21,
    viewBox: "0 0 22.69 21",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBasket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/basket.7cfc808a.svg";
export { ForwardRef as ReactComponent };